const chipModules = import.meta.glob('@/assets/chips/*.{png,jpg,jpeg,svg,webp}', {
  eager: true,
  import: 'default',
});

const getChipKey = (path) => {
  const filename = path.split('/').pop() || '';
  return filename.replace(/\.[^/.]+$/, '');
};

const isNumericKey = (chipKey) => /^\d+$/.test(chipKey);

const chipEntries = Object.entries(chipModules).map(([path, src]) => {
  const chipKey = getChipKey(path);
  return {
    chipKey,
    src,
    isNumeric: isNumericKey(chipKey),
    numericValue: isNumericKey(chipKey) ? Number(chipKey) : null,
  };
});

chipEntries.sort((a, b) => {
  if (a.isNumeric && b.isNumeric) {
    return a.numericValue - b.numericValue;
  }
  if (a.isNumeric !== b.isNumeric) {
    return a.isNumeric ? -1 : 1;
  }
  return a.chipKey.localeCompare(b.chipKey, 'en', { numeric: true, sensitivity: 'base' });
});

export const chips = chipEntries.map(({ chipKey, src }) => ({ chipKey, src }));

export const defaultChip = chips[0] || { chipKey: '', src: '' };

export const getChipByKey = (chipKey) => {
  if (chipKey === null || chipKey === undefined) {
    return null;
  }

  const key = String(chipKey);
  const matchedChip = chips.find((chip) => chip.chipKey === key);
  if (matchedChip) {
    return matchedChip;
  }

  return null;
};

export const getChipSrc = (chipKey) => getChipByKey(chipKey)?.src || null;
